export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12777.7267f9e7.jpg";